// import StickyPaynowButton from './sticky-paynow-button'

export default []
// export default [
//   StickyPaynowButton
// ]
